import { makeFetchSlice } from './fetchSlice';
import { entityKey, rosterKey } from './ids';

export const WORKSPACE_ACTIONS = {
  RESET: 'workspace/RESET',
  SET_FETCH_COHORTS: 'workspace/SET_FETCH_COHORTS',
  SET_FETCH_SESSIONS: 'workspace/SET_FETCH_SESSIONS',
  SET_FETCH_EVALUATIONS: 'workspace/SET_FETCH_EVALUATIONS',
  BOOT_ENTITIES: 'workspace/BOOT_ENTITIES',
  UPSERT_SESSION: 'workspace/UPSERT_SESSION',
  UPSERT_COHORT: 'workspace/UPSERT_COHORT',
  REMOVE_COHORT: 'workspace/REMOVE_COHORT',
  SET_ROSTER: 'workspace/SET_ROSTER',
};

export function createInitialWorkspaceState() {
  return {
    entities: {
      sessions: {},
      cohorts: {},
      evaluations: {},
    },
    rosters: {},
    fetch: {
      cohorts: makeFetchSlice([]),
      sessions: makeFetchSlice([]),
      evaluations: makeFetchSlice([]),
    },
  };
}

function upsertEntityMap(map, entity) {
  if (!entity?.id) return map;
  return { ...map, [entityKey(entity.id)]: entity };
}

export function workspaceReducer(state, action) {
  switch (action.type) {
    case WORKSPACE_ACTIONS.RESET:
      return createInitialWorkspaceState();

    case WORKSPACE_ACTIONS.SET_FETCH_COHORTS:
      return { ...state, fetch: { ...state.fetch, cohorts: action.payload } };

    case WORKSPACE_ACTIONS.SET_FETCH_SESSIONS:
      return { ...state, fetch: { ...state.fetch, sessions: action.payload } };

    case WORKSPACE_ACTIONS.SET_FETCH_EVALUATIONS:
      return { ...state, fetch: { ...state.fetch, evaluations: action.payload } };

    case WORKSPACE_ACTIONS.BOOT_ENTITIES: {
      const { sessions = [], cohorts = [], evaluations = [], rosters = {} } = action.payload;
      const sessionMap = {};
      sessions.forEach(session => {
        if (session?.id) sessionMap[entityKey(session.id)] = session;
      });
      const cohortMap = {};
      cohorts.forEach(cohort => {
        if (cohort?.id) cohortMap[entityKey(cohort.id)] = cohort;
      });
      const evaluationMap = {};
      evaluations.forEach(evaluation => {
        if (evaluation?.id) evaluationMap[entityKey(evaluation.id)] = evaluation;
      });
      return {
        ...state,
        entities: {
          sessions: sessionMap,
          cohorts: cohortMap,
          evaluations: evaluationMap,
        },
        rosters: { ...state.rosters, ...rosters },
      };
    }

    case WORKSPACE_ACTIONS.UPSERT_SESSION: {
      const session = action.payload;
      if (!session?.id) return state;
      return {
        ...state,
        entities: {
          ...state.entities,
          sessions: upsertEntityMap(state.entities.sessions, session),
        },
      };
    }

    case WORKSPACE_ACTIONS.UPSERT_COHORT: {
      const cohort = action.payload;
      if (!cohort?.id) return state;
      return {
        ...state,
        entities: {
          ...state.entities,
          cohorts: upsertEntityMap(state.entities.cohorts, cohort),
        },
      };
    }

    case WORKSPACE_ACTIONS.REMOVE_COHORT: {
      const cohortId = action.payload;
      const key = entityKey(cohortId);
      if (!key || !state.entities.cohorts[key]) return state;
      const cohorts = { ...state.entities.cohorts };
      delete cohorts[key];
      return {
        ...state,
        entities: { ...state.entities, cohorts },
      };
    }

    case WORKSPACE_ACTIONS.SET_ROSTER: {
      const { schoolId, branchId, students } = action.payload;
      const key = rosterKey(schoolId, branchId);
      return {
        ...state,
        rosters: { ...state.rosters, [key]: students || [] },
      };
    }

    default:
      return state;
  }
}